module.exports = __webpack_public_path__ + "img/hospital.20b5536e.png";